import React from "react"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import HoldsPicker from "../../../components/v2/inputs/pickers/HoldsPicker"
import { USER } from "../../../library/store/actions/types/authTypes"
import MeetTypeSwitcher from "../../bookMeet/component/MeetTypeSwitcher"
import { useSolicitAppointments } from "./SolicitAppointmentsContext"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import Button from "@material-ui/core/Button"

const SolicitAppointmentStep1 = () => {
  const { data, setData, availableTypes, onClose, setStep } =
    useSolicitAppointments()

  const toNextStep = () => setStep(2)

  const canGoNext = data.hold && data.type

  return (
    <>
      <DialogContent className={"pb15"}>
        <div className="f jcc mb50">
          <p className="text-center" style={{ maxWidth: 340 }}>
            Please select by Hold and by appointment length in minutes. A Hold
            is a bracketed open time that can be scheduled with this user and
            will usually be labeled for selection appropriate to the requester.
            not selecting a Hold will use any open time and the user can elect
            to accept or offer a different time.
          </p>
        </div>
        <div className="full-width f jcc">
          <div className="form form--modal">
            <HoldsPicker
              required
              value={data.hold}
              onChange={(h) =>
                setData((prevState) => ({ ...prevState, hold: h }))
              }
              requestConfig={{
                fetchConfig: {
                  apiUrl: USER.HOLDS.LIST,
                },
                key: "list",
              }}
            />
            <MeetTypeSwitcher
              availableTypes={availableTypes}
              value={data.type}
              onChange={(v) =>
                setData((prevState) => ({
                  ...prevState,
                  type: v,
                  time: null,
                  date: null,
                }))
              }
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button color="primary" onClick={toNextStep} disabled={!canGoNext}>
          Next
        </Button>
      </DialogActions>
    </>
  )
}

export default SolicitAppointmentStep1
